import * as React from "react";

import RaisedButton from "material-ui/RaisedButton";

const HTTP_VERB_COLORS = {
	"": "grey",
	get: "green",
	post: "#00aeff",
	patch: "purple",
	put: "orange",
	delete: "red",
};

interface HttpVerbButtonProps {
	verb: string;
	onClick?: () => void;
	style?: React.CSSProperties;
}

const HttpVerbButton = (props: HttpVerbButtonProps) => (
	<RaisedButton
		label={props.verb}
		labelColor={"#FFFFFF"}
		backgroundColor={HTTP_VERB_COLORS[props.verb.toLowerCase()] || HTTP_VERB_COLORS[""]}
		style={props.style}
		onClick={props.onClick}
	/>
);

export default HttpVerbButton;



// WEBPACK FOOTER //
// ./src/components/HttpVerbButton.tsx